import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CountPipe } from './array/count.pipe';
import { MiddleclickDirective } from './directives/middleclick.directive';
import { DirectusImageUrlPipe } from './image/directus-image.pipe';
import { ImageUrlPipe } from './image/image.pipe';
import { FuzzyAutocompleteHighlightPipe } from './string/autocomplete-highlight-fuzzy.pipe';
import { AutocompleteHighlightPipe } from './string/autocomplete-highlight.pipe';
import { ContactNamePipe } from './string/contact-name.pipe';
import { DayFromDatetimePipe } from './string/day-from-datetime.pipe';
import { DurationFromDatetimePipe } from './string/duration-from-datetime.pipe';
import { HumanReadableFilesizePipe } from './string/human-readable-filesize.pipe';
import { TransformLinefeedPipe } from './string/linefeed-transformation.pipe';
import { LocationNamePipe } from './string/location-name.pipe';
import { SafeUrlPipe } from './string/safe-url.pipe';
import { StripHtmlTags } from './string/strip-html-tags';
import { FilterAllowedWYSIWYGTagsPipe } from './string/wysiwyg-tag-filter.pipe';

@NgModule({
  declarations: [
    FilterAllowedWYSIWYGTagsPipe,
    SafeUrlPipe,
    ContactNamePipe,
    CountPipe,
    ImageUrlPipe,
    DayFromDatetimePipe,
    DurationFromDatetimePipe,
    LocationNamePipe,
    TransformLinefeedPipe,
    MiddleclickDirective,
    AutocompleteHighlightPipe,
    FuzzyAutocompleteHighlightPipe,
    HumanReadableFilesizePipe,
  ],
  imports: [CommonModule, DirectusImageUrlPipe, StripHtmlTags],
  exports: [
    FilterAllowedWYSIWYGTagsPipe,
    SafeUrlPipe,
    ContactNamePipe,
    CountPipe,
    ImageUrlPipe,
    DayFromDatetimePipe,
    DurationFromDatetimePipe,
    LocationNamePipe,
    TransformLinefeedPipe,
    MiddleclickDirective,
    AutocompleteHighlightPipe,
    FuzzyAutocompleteHighlightPipe,
    HumanReadableFilesizePipe,
    DirectusImageUrlPipe,
    StripHtmlTags,
  ],
})
export class SharedUtilPipelinesModule {}
